export default __webpack_public_path__ + "static/media/CV3.1f1fa00d.png";